import { Tabs } from "antd";
import { useState } from "react";
import { CashDeposit } from "./deposit";
import PaymentTabs from "./PaymentTabs";
import Refunds from "./Refunds";
import WalletTopUps from "./WalletTopUps";
import {
  FileTextOutlined,
  CreditCardOutlined,
  WalletOutlined,
  RollbackOutlined,
} from "@ant-design/icons";

import { usePermissions } from "../../custom_hooks/permission/permission_hook";

const { TabPane } = Tabs;

export default function CashLogPage() {
  const { hasPermission } = usePermissions();
  const canViewPayments = hasPermission("finance.create");

  const [activeTab, setActiveTab] = useState(canViewPayments ? "payments" : "cash-log");

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <main className="p-4">
      <section className="bg-white rounded p-4">
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          className="cash-log-tabs"
        >
          {canViewPayments && (
            <TabPane
              tab={
                <span>
                  <CreditCardOutlined />
                  <span>Payments</span>
                </span>
              }
              key="payments"
            >
              <div className="mt-3">
                <PaymentTabs />
              </div>
            </TabPane>
          )}

          <TabPane
            tab={
              <span>
                <FileTextOutlined />
                <span>Cash Log</span>
              </span>
            }
            key="cash-log"
          >
            <CashDeposit />
          </TabPane>

          {canViewPayments && (
            <TabPane
              tab={
                <span>
                  <WalletOutlined />
                  <span>Wallet Top-ups</span>
                </span>
              }
              key="wallet-top-ups"
            >
              <WalletTopUps />
            </TabPane>
          )}

          {/* Payouts owed on refunds raised from the OMS screen. Each refund fans out into one leg
              per payment it was drained from; the legs that need a human are recorded here. */}
          {canViewPayments && (
            <TabPane
              tab={
                <span>
                  <RollbackOutlined />
                  <span>Refunds</span>
                </span>
              }
              key="refunds"
            >
              <div className="mt-3">
                <Refunds />
              </div>
            </TabPane>
          )}
        </Tabs>
      </section>
    </main>
  );
}
